"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Layout = exports.Header = exports.GalleryPendingContact = exports.PendingContact = exports.BlockedContact = exports.ApprovedContact = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactVirtualized = require("react-virtualized");

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));

var _Avatar = require("../../components/Avatar");

var _SearchInputHeader = _interopRequireDefault(require("../../components/SearchInputHeader"));

var CONTACT_LIST_ITEM_HEIGHT = 70;

var AvatarColumn = function AvatarColumn(_ref) {
  var _ref$ssFlag = _ref.ssFlag,
      ssFlag = _ref$ssFlag === void 0 ? false : _ref$ssFlag,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["ssFlag", "children"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: "flex-grow-0 flex-shrink-0 mx-8"
  }), ssFlag ? /*#__PURE__*/_react["default"].createElement(_Avatar.IconAvatar, {
    icon: /*#__PURE__*/_react["default"].createElement(_Error["default"], {
      style: {
        fontSize: '3rem'
      }
    }),
    containerProps: {
      className: '!w-10 !h-10'
    }
  }) : children);
};

var NameColumn = function NameColumn(props) {
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: "flex-grow-0 flex-shrink-0 w-full px-2 font-bold leading-snug truncate sm:w-56 text-dark"
  }));
};

var EmailColumn = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "flex-grow-0 flex-shrink-0 w-full px-2 text-xs truncate sm:w-64 xl:text-sm font-semibold text-light"
  }));
});

var NameAndEmailColumn = function NameAndEmailColumn(_ref2) {
  var name = _ref2.name,
      email = _ref2.email;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow-0 flex-shrink-0 w-full px-2 leading-snug sm:w-56"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold text-dark"
  }, name), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs text-light"
  }, email));
};

var SnippetColumn = function SnippetColumn(props) {
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: "flex-1 w-full px-2 text-xs truncate text-light"
  }));
};

var UnblockActionColumn = function UnblockActionColumn(_ref3) {
  var _onClick = _ref3.onClick,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["onClick"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow-0 flex-shrink-0 px-2"
  }, /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, props, {
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick && _onClick(e);
    },
    className: (0, _classnames["default"])('rounded-full px-6 py-1 text-xs font-semibold bg-secondary dark:bg-card text-primary hover:shadow')
  }), "Unblock"));
};

var BlockActionColumn = function BlockActionColumn(_ref4) {
  var _onClick2 = _ref4.onClick,
      className = _ref4.className,
      props = (0, _objectWithoutProperties2["default"])(_ref4, ["onClick", "className"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow-0 flex-shrink-0 px-2"
  }, /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, props, {
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick2 && _onClick2(e);
    },
    className: (0, _classnames["default"])('rounded-full px-6 py-1 text-xs font-semibold border', className)
  }), "Block"));
};

var AcceptActionColumn = function AcceptActionColumn(_ref5) {
  var _onClick3 = _ref5.onClick,
      className = _ref5.className,
      props = (0, _objectWithoutProperties2["default"])(_ref5, ["onClick", "className"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow-0 flex-shrink-0 px-2"
  }, /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, props, {
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick3 && _onClick3(e);
    },
    className: (0, _classnames["default"])('rounded-full px-6 py-1 text-xs font-semibold text-primary', className)
  }), "Accept"));
};

var ReadReceiptBlockingColumn = function ReadReceiptBlockingColumn(_ref6) {
  var flag = _ref6.flag,
      rest = (0, _objectWithoutProperties2["default"])(_ref6, ["flag"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    className: "flex-grow-0 flex-shrink-0 sm:w-10"
  }), flag && /*#__PURE__*/_react["default"].createElement(_VisibilityOff["default"], {
    fontSize: "small",
    className: "text-light opacity-50"
  }));
};

var Columns = function Columns(_ref7) {
  var _ref7$clickable = _ref7.clickable,
      clickable = _ref7$clickable === void 0 ? true : _ref7$clickable,
      _ref7$hoverable = _ref7.hoverable,
      hoverable = _ref7$hoverable === void 0 ? true : _ref7$hoverable,
      rest = (0, _objectWithoutProperties2["default"])(_ref7, ["clickable", "hoverable"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    className: (0, _classnames["default"])('flex py-2 select-none text-sm px-6 items-center', {
      'cursor-pointer': clickable
    }, {
      'hover:shadow-hover dark:hover:bg-secondary': hoverable
    })
  }));
};

var ApprovedContact = function ApprovedContact(_ref8) {
  var avatar = _ref8.avatar,
      name = _ref8.name,
      email = _ref8.email,
      rest = (0, _objectWithoutProperties2["default"])(_ref8, ["avatar", "name", "email"]);
  return /*#__PURE__*/_react["default"].createElement(Columns, rest, /*#__PURE__*/_react["default"].createElement(AvatarColumn, null, avatar), /*#__PURE__*/_react["default"].createElement(NameColumn, null, name), /*#__PURE__*/_react["default"].createElement(EmailColumn, null, email));
};

exports.ApprovedContact = ApprovedContact;

var BlockedContact = function BlockedContact(_ref9) {
  var avatar = _ref9.avatar,
      name = _ref9.name,
      email = _ref9.email,
      onUnblock = _ref9.onUnblock,
      rest = (0, _objectWithoutProperties2["default"])(_ref9, ["avatar", "name", "email", "onUnblock"]);
  return /*#__PURE__*/_react["default"].createElement(Columns, rest, /*#__PURE__*/_react["default"].createElement(AvatarColumn, null, avatar), /*#__PURE__*/_react["default"].createElement(NameColumn, null, name), /*#__PURE__*/_react["default"].createElement(EmailColumn, null, email), /*#__PURE__*/_react["default"].createElement(UnblockActionColumn, {
    onClick: onUnblock
  }));
};

exports.BlockedContact = BlockedContact;

var PendingContact = function PendingContact(_ref10) {
  var avatar = _ref10.avatar,
      name = _ref10.name,
      email = _ref10.email,
      ssFlag = _ref10.ssFlag,
      rrbFlag = _ref10.rrbFlag,
      snippet = _ref10.snippet,
      onBlock = _ref10.onBlock,
      onAccept = _ref10.onAccept,
      onMouseOver = _ref10.onMouseOver,
      _onMouseLeave = _ref10.onMouseLeave,
      rest = (0, _objectWithoutProperties2["default"])(_ref10, ["avatar", "name", "email", "ssFlag", "rrbFlag", "snippet", "onBlock", "onAccept", "onMouseOver", "onMouseLeave"]);
  var ref = (0, _react.useRef)(null);
  var debouncedOnMouseOver = (0, _react.useMemo)(function () {
    return (0, _debounce["default"])(function () {
      return onMouseOver && onMouseOver(ref.current);
    }, 500);
  }, [onMouseOver, ref.current]);
  return /*#__PURE__*/_react["default"].createElement(Columns, rest, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-1 truncate items-center",
    onMouseOver: debouncedOnMouseOver,
    onMouseLeave: function onMouseLeave() {
      debouncedOnMouseOver.cancel();
      _onMouseLeave && _onMouseLeave(null);
    }
  }, /*#__PURE__*/_react["default"].createElement(AvatarColumn, {
    ssFlag: ssFlag
  }, avatar), /*#__PURE__*/_react["default"].createElement(NameColumn, null, name), /*#__PURE__*/_react["default"].createElement(ReadReceiptBlockingColumn, {
    flag: rrbFlag
  }), /*#__PURE__*/_react["default"].createElement(EmailColumn, {
    ref: ref
  }, email), /*#__PURE__*/_react["default"].createElement(SnippetColumn, null, snippet)), /*#__PURE__*/_react["default"].createElement(BlockActionColumn, {
    onClick: onBlock,
    className: "hover:shadow bg-app"
  }), /*#__PURE__*/_react["default"].createElement(AcceptActionColumn, {
    onClick: onAccept,
    className: "bg-secondary dark:bg-card hover:shadow"
  }));
};

exports.PendingContact = PendingContact;

var GalleryPendingContact = function GalleryPendingContact(_ref11) {
  var checkbox = _ref11.checkbox,
      avatar = _ref11.avatar,
      name = _ref11.name,
      email = _ref11.email,
      onBlock = _ref11.onBlock,
      onAccept = _ref11.onAccept,
      onClick = _ref11.onClick,
      rest = (0, _objectWithoutProperties2["default"])(_ref11, ["checkbox", "avatar", "name", "email", "onBlock", "onAccept", "onClick"]);
  return /*#__PURE__*/_react["default"].createElement(Columns, (0, _extends2["default"])({}, rest, {
    hoverable: false
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-1 truncate items-center"
  }, checkbox, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onClick,
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement(AvatarColumn, null, avatar), /*#__PURE__*/_react["default"].createElement(NameAndEmailColumn, {
    name: name,
    email: email
  }))), /*#__PURE__*/_react["default"].createElement(BlockActionColumn, {
    onClick: onBlock,
    className: "hover:bg-secondary"
  }), /*#__PURE__*/_react["default"].createElement(AcceptActionColumn, {
    onClick: onAccept,
    className: "bg-secondary hover:shadow dark:hover:shadow-shallow"
  }));
};

exports.GalleryPendingContact = GalleryPendingContact;

var Header = function Header(_ref12) {
  var keyword = _ref12.keyword,
      onChange = _ref12.onChange,
      avatar = _ref12.avatar;
  return /*#__PURE__*/_react["default"].createElement(_SearchInputHeader["default"], {
    keyword: keyword,
    onChange: onChange,
    accountAvatar: avatar
  }, "Contacts");
};

exports.Header = Header;

var Layout = function Layout(_ref13) {
  var header = _ref13.header,
      children = _ref13.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-screen flex flex-col"
  }, header, /*#__PURE__*/_react["default"].createElement("div", {
    className: "md:mt-4 flex-1 bg-app h-full py-8"
  }, children));
};

exports.Layout = Layout;

var _default = /*#__PURE__*/(0, _react.forwardRef)(function (_ref14, ref) {
  var _ref14$count = _ref14.count,
      count = _ref14$count === void 0 ? 0 : _ref14$count,
      rowRenderer = _ref14.rowRenderer,
      props = (0, _objectWithoutProperties2["default"])(_ref14, ["count", "rowRenderer"]);
  return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, null, function (_ref15) {
    var height = _ref15.height,
        width = _ref15.width;
    return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.List, (0, _extends2["default"])({}, props, {
      ref: ref,
      style: {
        outline: 'none'
      },
      rowRenderer: rowRenderer,
      rowHeight: CONTACT_LIST_ITEM_HEIGHT,
      height: height,
      width: width,
      rowCount: count
    }));
  });
});

exports["default"] = _default;
//# sourceMappingURL=index.js.map